/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { BaseAppService } from '../../projects/icemedx-lib/src/services/baseapp.service';
import { LoginService } from '../../projects/icemedx-lib/src/login/login.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';

@Injectable()
export class AppService extends BaseAppService {
  
  constructor(navSvc: IceNavService,
    domainSvc: DomainService,
    loginSvc: LoginService, app: ApplicationRef) {
    super(navSvc, domainSvc, loginSvc, app);

    loginSvc = this.getLoginService();
    let usrInfo = loginSvc.GetSessionUserInfo();
    let hasProviders: boolean = loginSvc.hasDomainType(usrInfo, IceTypes.ACCOUNT_TYPE.actProvider)
      || loginSvc.hasDomainType(usrInfo, IceTypes.ACCOUNT_TYPE.actFacility);

    this.setCustomBrandName(null);
  }

  public defaultMenus() {
    super.defaultMenus();
    super.networkMenu();
  }
}
